import { FuelButton, FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'
import Row from '~components/Row'

export const Subtitle = styled(FuelTypography).attrs({ size: 'body-sm', color: 'neutral-default', weight: 'medium' })`
  p {
    padding-top: 8px;
    padding-bottom: 32px;
  }
`

export const Title = styled(FuelTypography).attrs({ size: 'heading-sm', color: 'neutral-strong', weight: 'bold' })``

export const Cellphone = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;

  :not(:last-child) {
    border-bottom-color: ${({ theme }) => theme.color.border.neutral.default};
    border-bottom-style: ${({ theme }) => theme.border.style.solid};
    border-bottom-width: ${({ theme }) => theme.border.width.thinner};
  }
`

export const Line = styled.div`
  background: ${({ theme }) => theme.color.background.neutral.weak};
  width: 100%;
  height: ${({ theme }) => theme.border.width.thick};
`

export const Number = styled(Row)`
  p {
    padding-left: ${({ theme }) => theme.spacing.km4};
  }
`

export const ConfirmButton = styled(FuelButton).attrs({
  size: 'large',
  fullWidth: true,
})`
  margin-top: ${({ theme }) => theme.spacing.km4};
`
